export class InventoryItem extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, textureKey, itemName, rarity = 'Normal', itemType = 'Misc', description = 'A mysterious item', value = 0) {
        super(scene, x, y, textureKey);
        
        this.setInteractive();
        scene.input.setDraggable(this);
        
        this.originalX = x;
        this.originalY = y;
        this.itemName = itemName;
        this.description = description;
        this.rarity = rarity;
        this.itemType = itemType;
        this.value = value;
        
    }
}